/*
 *   Copyright (c) 2025 Luxembourg Institute of Science and Technology
 *   All rights reserved.
 */

export default {
  primaryColor: "#6c1484",
  primaryColorFade1: "#ccc0d9",
  primaryColorFade2: "#f9eefc",
  colorHighlight: "#f79443",
  colorHighlightFade1: "#fdeada",
  colorHighlightFade2: "#dadbe0",
  colorBgBase: "#ffffff",
  colorTextBase: "#333333",
}
